import { adminHttpClient } from '../../../commons/adminHttpClient'
import OrderedPageFilter from '../../../commons/orderedPageFilter'
import PagedList from '../../../commons/pagedList'

export interface PagedReimbursementsHistory extends PagedList<ReimbursementHistoryItem> {}

export interface ReimbursementHistoryItem {
  companyUserId: string
  fullName: string
  scheduleDate: string
  amount: number
  maxAmountOnEdit: number
  taxable: number
  nonTaxed: number
}

export type ReimbursementHistoryFilter = OrderedPageFilter & {
  fromDate?: string
  toDate?: string
}
const getReimbursementsHistory = (
  planPeriodId: string,
  filter: ReimbursementHistoryFilter,
): Promise<PagedReimbursementsHistory> => {
  const formattedFilter = {
    ...filter,
  }
  return adminHttpClient.get(
    `/AdminDashboard/ReimbursementsHistory/${planPeriodId}/ReimbursementHistory`,
    formattedFilter,
  )
}

export default getReimbursementsHistory

export const getReimbursementsHistoryAsCsv = (
  planPeriodId: string,
  reimbursePaymentId?: string,
  filter?: ReimbursementHistoryFilter,
): Promise<any> => {
  return adminHttpClient.get(
    reimbursePaymentId
      ? `/AdminDashboard/ReimbursementsHistory/${planPeriodId}/CSV?reimbursePaymentId=${reimbursePaymentId}`
      : `/AdminDashboard/ReimbursementsHistory/${planPeriodId}/CSV`,
    {
      ...filter,
    },
  )
}
